//React
import cx from "classnames";
//Components
import {
  Accordion,
  AlphaInput,
  AlphaNumericInput,
  Button,
  Card,
  Checkbox,
  Dropdown,
  EmailRegistrationModal,
  FlexBox,
  Input,
  RupeeAmount,
  Screen,
  TitleBlock,
  TranslatedString,
  Image,
} from "components";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
//Styles
import "./styles.scss";
import PointingFinger from "assets/pointing-finger.png";
import PotraitCartoon from "assets/potrait-cartoon.png";
import { faqs } from "../../constants";

const Pricing = () => {
  //Constants
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [pricingType, setPricingType] = useState("Monthly");
  const [storySectionVisibility, setStorySectionVisibility] = useState(false);
  const storySectionRef: any = useRef(null);
  const [missionSectionVisibility, setMissionSectionVisibility] =
    useState(false);
  const missionSectionRef: any = useRef(null);
  const [visionSectionVisibility, setVisionSectionVisibility] = useState(false);
  const visionSectionRef: any = useRef(null);
  const [teamSectionVisibility, setTeamSectionVisibility] = useState(false);
  const teamSectionRef: any = useRef(null);

  useEffect(() => {
    window.addEventListener("scroll", onScroll, true);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const onScroll = (event: any) => {
    const docViewTop = window.pageYOffset;
    const storySectionTop = storySectionRef?.current?.offsetTop - 800;
    const missionSectionTop = missionSectionRef?.current?.offsetTop - 800;
    const visionSectionTop = visionSectionRef?.current?.offsetTop - 800;
    const teamSectionTop = teamSectionRef?.current?.offsetTop - 800;
    if (docViewTop >= storySectionTop && !storySectionVisibility) {
      setStorySectionVisibility(true);
    }
    if (docViewTop >= missionSectionTop && !missionSectionVisibility) {
      setMissionSectionVisibility(true);
    }
    if (docViewTop >= visionSectionTop && !visionSectionVisibility) {
      setVisionSectionVisibility(true);
    }
    if (docViewTop >= teamSectionTop && !teamSectionVisibility) {
      setTeamSectionVisibility(true);
    }
  };

  //Render UI
  const renderFaqs = (item: any, index: number) => {
    return (
      <Accordion
        title={item?.title}
        content={item.content}
        className={cx(
          index !== 0 && "mr-t-20",
          `delay-0${index + 1}s`,
          "animated fadeInUp"
        )}
        key={`${item?.title}-faq-${index}`}
      />
    );
  };

  //Return UI
  return (
    <Screen
      className="pricing-screen"
      hasHeader
      hasFooter
      screenAnimationClass="no-animation"
    >
      {/* First Section */}
      <div className="landing-div h-70 pd-h-60 mr-v-20">
        <div className="bg-theme h-100 w-100 br-12 content">
          <FlexBox justifyEvenly alignCenter className="text-section h-100">
            <div className="w-40">
              <p className="fs-48 font-heavy animated fadeInDown delay-01s">
                Pick a plan that's right for you
              </p>
              <p className="fs-20 font-light animated fadeInDown delay-03s mr-t-30">
                Pricing plan for business at every stage of growth
              </p>
              <FlexBox
                justifyCenter
                alignCenter
                className="rating-div animated fadeInDown delay-05s"
              >
                <p className="star fs-28 mr-r-20">&#9733;</p>
                <p>Rated 4.9/5 from over 520 Reviews</p>
              </FlexBox>
            </div>
            <Image
              src={PointingFinger}
              className="w-45 animated fadeInDown delay-01s"
            />
          </FlexBox>
        </div>
      </div>
      {/* Second Section */}
      <div
        className="pricing-section pd-h-60 mr-v-40 pd-v-60"
        ref={storySectionRef}
      >
        {storySectionVisibility && (
          <>
            <FlexBox
              justifyBetween
              alignCenter
              className="top-tab bg-theme br-12 pos-rel animated fadeInUp delay-03s"
            >
              <p
                className={cx(
                  pricingType === "Monthly" && "active",
                  "w-47 text-center curs-point"
                )}
                onClick={() => {
                  setPricingType("Monthly");
                }}
              >
                Monthly
              </p>
              <p
                className={cx(
                  pricingType === "Yearly" && "active",
                  "w-47 text-center curs-point"
                )}
                onClick={() => {
                  setPricingType("Yearly");
                }}
              >
                Yearly
              </p>
              <div
                className={cx(
                  pricingType === "Monthly" ? "left-active" : "right-active",
                  "active-tab"
                )}
              />
            </FlexBox>
            <FlexBox className="mr-v-40 prices" justifyEvenly alignCenter>
              <Card className="w-25 text-center animated fadeInLeft delay-01s">
                <FlexBox
                  flexColumn
                  alignCenter
                  className="w-47 bg-theme br-9 text-center img-div pd-20 w-100 mr-b-30"
                >
                  <p className="basic br-12 pd-v-10 pd-h-30 fs-16 font-medium clr-white">
                    Basic
                  </p>
                  <RupeeAmount
                    amount={50000}
                    amountClass="fs-44"
                    className="mr-t-20 mr-b-10 font-heavy"
                  />
                  <p className="fs-14">Per member, Per month</p>
                </FlexBox>
                <Checkbox
                  checked
                  onChange={() => {}}
                  label={"All limited links"}
                  className="pd-v-20 pd-h-10 border-bottom fs-16"
                />
                <Checkbox
                  checked
                  onChange={() => {}}
                  label={"Up to 10 blocks"}
                  className="pd-v-20 pd-h-10 border-bottom fs-16"
                />
                <Checkbox
                  checked
                  onChange={() => {}}
                  label={"Chat Support"}
                  className="pd-v-20 pd-h-10 border-bottom fs-16"
                />
                <Checkbox
                  checked
                  onChange={() => {}}
                  label={"Api Integration"}
                  className="pd-v-20 pd-h-10 border-bottom fs-16"
                />
                <Button
                  text={"Choose Plan"}
                  className="mr-t-30 w-80"
                  variant="outline"
                />
              </Card>
              <Card className="w-25 text-center animated fadeInLeft delay-03s">
                <FlexBox
                  flexColumn
                  alignCenter
                  className="w-47 bg-theme br-9 text-center img-div pd-20 w-100 mr-b-30"
                >
                  <p className="standard br-12 pd-v-10 pd-h-30 fs-16 font-medium clr-white">
                    Standard
                  </p>
                  <RupeeAmount
                    amount={100000}
                    amountClass="fs-44"
                    className="mr-t-20 mr-b-10 font-heavy"
                  />
                  <p className="fs-14">Per member, Per month</p>
                </FlexBox>
                <Checkbox
                  checked
                  onChange={() => {}}
                  label={"All limited links"}
                  className="pd-v-20 pd-h-10 border-bottom fs-16"
                />
                <Checkbox
                  checked
                  onChange={() => {}}
                  label={"Up to 10 blocks"}
                  className="pd-v-20 pd-h-10 border-bottom fs-16"
                />
                <Checkbox
                  checked
                  onChange={() => {}}
                  label={"Chat Support"}
                  className="pd-v-20 pd-h-10 border-bottom fs-16"
                />
                <Checkbox
                  checked
                  onChange={() => {}}
                  label={"Api Integrations"}
                  className="pd-v-20 pd-h-10 border-bottom fs-16"
                />
                <Button
                  text={"Choose Plan"}
                  className="mr-t-30 w-80"
                  variant="outline"
                />
              </Card>
              <Card className="w-25 text-center animated fadeInLeft delay-05s">
                <FlexBox
                  flexColumn
                  alignCenter
                  className="w-47 bg-theme br-9 text-center img-div pd-20 w-100 mr-b-30"
                >
                  <p className="pro br-12 pd-v-10 pd-h-30 fs-16 font-medium clr-white">
                    Pro
                  </p>
                  <RupeeAmount
                    amount={150000}
                    amountClass="fs-44"
                    className="mr-t-20 mr-b-10 font-heavy"
                  />
                  <p className="fs-14">Per member, Per month</p>
                </FlexBox>
                <Checkbox
                  checked
                  onChange={() => {}}
                  label={"All limited links"}
                  className="pd-v-20 pd-h-10 border-bottom fs-16"
                />
                <Checkbox
                  checked
                  onChange={() => {}}
                  label={"Up to 10 blocks"}
                  className="pd-v-20 pd-h-10 border-bottom fs-16"
                />
                <Checkbox
                  checked
                  onChange={() => {}}
                  label={"Chat Support"}
                  className="pd-v-20 pd-h-10 border-bottom fs-16"
                />
                <Checkbox
                  checked
                  onChange={() => {}}
                  label={"Api Integrations"}
                  className="pd-v-20 pd-h-10 border-bottom fs-16"
                />
                <Button
                  text={"Choose Plan"}
                  className="mr-t-30 w-80"
                  variant="outline"
                />
              </Card>
            </FlexBox>
          </>
        )}
      </div>
      {/* Third Section */}
      <div
        className="team-section pd-h-60 mr-v-40 pd-v-40"
        ref={missionSectionRef}
      >
        {missionSectionVisibility && (
          <>
            <p className="text-center font-heavy fs-48 w-70 mr-au animated fadeInUp delay-01s">
              {" "}
              Frequently Asked Questions
            </p>
            <div className="mr-v-40 pd-v-20">{faqs?.map(renderFaqs)}</div>
          </>
        )}
      </div>
    </Screen>
  );
};

export default Pricing;
